import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
    display: "grid",
    gridTemplateColumns: theme.gridTemplateColumns[1],
    alignItems: "flex-start",
}));

export const Body = styled("div")(({ theme }) => ({
    display: "grid",
    gridTemplateColumns: theme.gridTemplateColumns[1],
    alignItems: "flex-start",
}));

export const Description = styled("div")(({ theme }) => ({
    marginTop: theme.spacing[2],
    fontSize: theme.fontSize["2xs"],
    "& label": {
        display: "block",
        color: theme.colors.gray[600],
        lineHeight: 1.5,
    },
}));

export const InlineError = styled("div")(({ theme }) => ({
    marginTop: theme.spacing[2],
    fontSize: theme.fontSize["2xs"],
    "& label": {
        display: "block",
        color: theme.colors.red[500],
        lineHeight: 1.5,
    },
}));
